<div class="page-content-small page-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 1050px">
            <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="3" (onEditorEnterKey)="search()">
                <dxi-item itemType="group" [colSpan]="3" [colCount]="3">
                    <dxi-item
                        dataField="salesRepId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Sales Rep' }"
                        [editorOptions]="{ items: salesReps, valueExpr: 'id', displayExpr: 'name' }"
                    ></dxi-item>
                    <dxi-item dataField="submittedStart" editorType="dxDateBox" [label]="{ text: 'Submitted From' }"></dxi-item>
                    <dxi-item dataField="submittedEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                </dxi-item>
            </dx-form>
            <div class="btn-toolbar justify-content-end align-items-center mt-1">
                <button accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                <button (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
            </div>
        </div>
    </div>
    <div class="flex-fill d-flex flex-column">
        <div class="m-1 grid-fill">
            <dx-data-grid #dataGrid [dataSource]="filteredOrders" keyExpr="id" [columnAutoWidth]="false" (onToolbarPreparing)="onToolbarPreparing($event)">
                <dxi-column dataField="invoiceNumber" caption="Sales Order #" width="80"></dxi-column>
                <dxi-column dataField="dealer.companyName" caption="Dealer" width="200"></dxi-column>
                <dxi-column dataField="salesRep.name" caption="Sales Rep" width="150"></dxi-column>
                <dxi-column dataField="pONumber" caption="PO #" width="200"></dxi-column>
                <dxi-column dataField="shippingAddressDisplay" caption="Shipping" width="200"></dxi-column>
                <dxi-column dataField="createDate" caption="Order Date" width="100"></dxi-column>
                <dxi-column dataField="statusName" caption="Status" width="100"></dxi-column>
                <dxi-column dataField="deliveryOption.name" caption="Delivery Option" width="125"></dxi-column>
                <dxi-column dataField="submitted" width="100"></dxi-column>
                <dxi-column dataField="total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                <dxi-column dataField="freight" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                <dxi-column dataField="net" caption="Total - Freight" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                <dxi-column dataField="paymentMethod" width="200"></dxi-column>

                <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="commissions-grid"></dxo-state-storing>

                <dxo-summary>
                    <dxi-total-item column="total" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                    <dxi-total-item column="freight" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                    <dxi-total-item column="net" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                </dxo-summary>

                <div *dxTemplate="let data of 'toolbarButtons'"></div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="filteredOrders" class="me-3"
                        ><strong
                            >{{ dataGrid.instance.totalCount() + ' items' }}
                            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                        </strong></span
                    >
                </div>
            </dx-data-grid>
        </div>
    </div>
</div>
